/**
 *
 * DateBadge
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import ClassNames from 'classnames';

const styles = theme => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 8,
    background: theme.palette.primary.main,
    width: 58,
    zIndex: 9,
  },
  text: {
    fontWeight: 450,
    color: '#fff',
    lineHeight: 1,
  },
  value: {
    fontSize: 25,
  },
  label: {
    fontSize: 14,
  },
});

function DateBadge({ date, classes }) {
  if (!date) return null;
  const formattedDate = format(date, 'MMM DD');
  const [month, day] = formattedDate.split(' ');
  return (
    <div className={classes.root}>
      <Typography
        className={ClassNames(classes.text, classes.value)}
        align="center"
      >
        {month}
      </Typography>
      <Typography
        className={ClassNames(classes.text, classes.label)}
        align="center"
      >
        {day}
      </Typography>
    </div>
  );
}

DateBadge.propTypes = {
  date: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(styles)(DateBadge);
